import React from "react";

const ImageVolumeMute = (props) => {
	return (
		<svg
			className="image-volume-mute unclickable"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			width="24"
			height="24"
			viewBox="0 0 24 24"
		>
			<path
				transform="translate(2 4)"
				className="image-fill-color"
				style={{ fill: props.fillOverride }}
				d="M4.075 4l5.911-4v16l-5.748-4H0V4h4.075zm15.911-.86v2.575L17.482 8l2.504 2.285v2.575L16.07 9.288 12 13v-2.576L14.658 8 12 5.576V3l4.07 3.712 3.916-3.572z"
			/>
		</svg>
	);
};

export default ImageVolumeMute;
